import { memo } from "react";

import { type CloudFlowNodeType } from "@doitintl/cmp-models";
import { Chip } from "@mui/material";

import { colors } from "../../../../muiTheme";
import { type RFNode } from "../../types";
import { getNodeTitle } from "../utils/nodeUtils";
import { SourceHandle, TargetHandle } from "./Handle";
import { RoundedNodeIcon } from "./NodeIcon";
import NodeWrapper from "./NodeWrapper";

type Props = {
  id: string;
  selected?: boolean;
  data: RFNode<CloudFlowNodeType.ACTION>;
};

const NoActionNode = ({ id, data, selected }: Props) => (
  <>
    <NodeWrapper
      title={getNodeTitle(data)}
      status={data.isBlueprintPresentationMode ? "validated" : data.nodeData.status || "error"}
      errorMessages={data.isBlueprintPresentationMode ? {} : data.nodeData.errorMessages || {}}
      onEdit={data.onEditNode}
      onDelete={data.onDeleteNode}
      isActive={!!selected}
      icon={<RoundedNodeIcon node={data} />}
      name={`${data.stepNumber}. ${data.nodeData.name}`}
    >
      {data.nodeData.approval?.required && (
        <Chip
          label="Approval needed"
          size="small"
          sx={{
            background: colors.light.info.background,
          }}
        />
      )}
    </NodeWrapper>
    <SourceHandle id={id} />
    <TargetHandle id={id} />
  </>
);

export const ActionNode = memo(NoActionNode);
